export class MemberGetMember {
  private promise?: Promise<any>
  private src: string

  constructor(src: string) {
    this.src = src
  }

  public track(eventName: string, params: any) {
    return new Promise((resolve, reject) => {
      this._load().then(() => {
        if (params.is_member_get_member) {
          const w = window as any
          delete params.is_member_get_member
          w.mgmcoPing.voucher(params)
        }
        resolve(params)
      })
    })
  }

  private _load() {
    return (
      this.promise ||
      (this.promise = new Promise<void>((resolve, reject) => {
        const script = document.createElement('script')
        script.type = 'text/javascript'
        script.async = true
        script.src = `${this.src}/scripts/ping.js`

        script.onload = () => {
          resolve()
        }

        script.onerror = error => {
          reject(error)
        }

        document.head.appendChild(script)
      }))
    )
  }
}
